module.exports = __webpack_public_path__ + "img/nissan03.9e964e93.png";